import { Body14Regular } from "@/components/typography/Body14Regular";
import { QuoteDetailDto } from "@/types/dto/quote-detail-dto";
import { Table } from "flowbite-react";
import { CustomCell } from "../../../../components/table/CustomCell";

interface Props {
  quoteDetail: QuoteDetailDto;
}

export const PartnerQuoteDetailOrdererTable: React.FC<Props> = ({
  quoteDetail,
}) => {
  const headCellStyle = "font-medium text-gray-900 bg-gray-100";

  return (
    <div className="overflow-x-auto flex flex-col gap-[16px]">
      <div className="overflow-hidden border rounded-lg">
        <Table>
          <Table.Body>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    고객명
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[480px] bg-primary-white">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {quoteDetail.ordererName}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
              >
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    고객 연락처
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[480px] bg-primary-white">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {quoteDetail.ordererPhone}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};
